<template>
	<div id="marketing-campaings-module" class="m-4">
        <!-- TITLE -->
        <div class="vx-row mb-4">
            <div class="vx-col w-full lg:w-full">
                <vx-card class="mt-2" card-background="dark">
                    <h1 class="bold big-title m-0 text-white">
                        Gestión de campañas <span class="success">promocionales</span>.</h1>
                </vx-card>
            </div>
        </div>

		<!-- CONTENT -->

		<div class="vx-row">
			<div class="vx-col w-full">
				<vx-card title="Administración">
					<vs-tabs>
						<vs-tab label="Campañas">
							<Campaigns></Campaigns>
						</vs-tab>
						<vs-tab label="Plantillas">
							<Templates></Templates>
						</vs-tab>
					</vs-tabs>
				</vx-card>
			</div>
		</div>
	</div>
</template>

<script lang="js">

import Campaigns from './Campaigns/Campaigns.vue';
import Templates from './Templates/Templates.vue';

export default {
	name: 'emails',
	components: {
		Campaigns,
		Templates
	}
}
</script>
